import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { SEOHead } from '../components/site/SEOHead';
import api, { getFileUrl } from '../lib/api';

export default function CustomPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [siblings, setSiblings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/custom-pages/${slug}`).then(r => {
      setPage(r.data);
      // Load sibling pages if this is a child
      if (r.data.parent_id && r.data.parent_id !== 'None') {
        api.get('/custom-pages?active_only=true').then(res => {
          const sibs = res.data.filter(p => p.parent_id === r.data.parent_id && p.id !== r.data.id);
          setSiblings(sibs);
        }).catch(() => {});
      }
    }).catch(() => {}).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" /></div>;
  if (!page) return <div className="min-h-screen flex flex-col items-center justify-center"><p className="text-muted-foreground mb-4">Sayfa bulunamadı</p><Link to="/" className="text-[hsl(var(--gold))]">Anasayfaya dön</Link></div>;

  return (
    <div data-testid="custom-page">
      <SEOHead title={page.title} />
      {/* Hero */}
      <div className="relative py-16 md:py-24 bg-[#0f1419]">
        {page.cover_image && (
          <div className="absolute inset-0 opacity-20">
            <img src={getFileUrl(page.cover_image)} alt="" className="w-full h-full object-cover" />
          </div>
        )}
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">{page.title}</h1>
          <div className="mt-4 w-16 h-1 rounded-full bg-[hsl(var(--gold))]" />
        </div>
      </div>

      <section className="py-14 md:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            {/* Main Content */}
            <div className={siblings.length > 0 ? 'lg:col-span-3' : 'lg:col-span-4'}>
              {(() => {
                const c = page.content || '';
                const isHtml = /<\/?[a-z][\s\S]*>/i.test(c);
                const hasText = c.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length > 0;
                if (!hasText) return <p className="text-muted-foreground">Bu sayfada henüz içerik yok.</p>;
                return isHtml
                  ? <div className="rich-content max-w-none" dangerouslySetInnerHTML={{ __html: c }} />
                  : <p className="text-sm md:text-base leading-relaxed text-muted-foreground whitespace-pre-line">{c}</p>;
              })()}
            </div>
            {/* Sidebar - sibling pages */}
            {siblings.length > 0 && (
              <div className="lg:col-span-1">
                <div className="p-4 rounded-xl bg-card border border-border">
                  <h3 className="font-heading text-sm font-semibold mb-3">Diğer Sayfalar</h3>
                  <ul className="space-y-1.5">
                    {siblings.map(s => (
                      <li key={s.id}>
                        <Link to={`/sayfa/${s.slug}`} className="block px-3 py-2 text-sm rounded-lg hover:bg-secondary transition-colors">{s.title}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
